import "./HelloWorld.css"

export const HelloWorld = () => (
  <div className="hello-card mx-auto w-80 mt-32 text-center bg-slate-800 animate-bounce">
    <h1 className="text-3xl text-gray-300">Hello World!</h1>
  </div>
)